import React from 'react';

const DownloadIcon = (props) => {
  return (
    <svg width='32' height='32' viewBox='0 0 32 32' {...props}>
      <g fill='currentColor' fillRule='nonzero'>
        <path d='m15.868 20.991-.184-.042-.082-.031-.096-.048-.095-.062-.062-.049-3.5-3a1 1 0 0 1 1.201-1.594l.1.076L15 17.826V8a1 1 0 0 1 1.993-.117L17 8v9.825l1.85-1.584a1 1 0 0 1 1.391 1.43l-.09.088-3.509 3.008-.077.058-.107.064-.125.054-.115.033-.132.02L16 21a1.01 1.01 0 0 1-.132-.009z' />
        <path d='M9.5 26a3.5 3.5 0 0 1-3.495-3.308L6 22.5V21a1 1 0 0 1 2 0v1.5a1.5 1.5 0 0 0 1.356 1.493L9.5 24h13a1.5 1.5 0 0 0 1.493-1.356L24 22.5V21a1 1 0 0 1 2 0v1.5a3.5 3.5 0 0 1-3.308 3.495L22.5 26h-13z' />
      </g>
    </svg>
  );
};

export default DownloadIcon;
